import React from "react";

const WorkItems = ({ item }) => {
  return (
    <a href={item.demo} className="work__card" target="_blank" rel="noreferrer">
      <img src={item.image} alt={item.title} className="work__img" />

      <h3
        className="work__title"
        dangerouslySetInnerHTML={{ __html: item.title }}
      />

      <span className="work__button">
        View Project <i className="bx bx-right-arrow-alt work__button-icon"></i>
      </span>
    </a>
  );
};

export default WorkItems;
